export default __webpack_public_path__ + "static/media/order_no.1e611c0f.svg";